(function selectListDataProvider(global) {
  "use strict";

  global.SelectListDataProvider = WA.CMP.dataViews.BaseDataProvider.extend({
    className: 'SelectListDataProvider',
    _cachedPages: {},
    lastLike: '',
    lastExpression: '',
    settings: null,
    lastCurrentPeriodEnabled: null,

    init: function (settings) {
      var me = this;
      me._super();
      me._cachedPages = {};
      me.settings = $.extend({}, settings);
    },

    load: function (loadOptions) {
      var me = this;
      var result = $.Deferred();
      var selectedRecords = [];
      var notSelectedRecords = [];
      var specialRecords = [];

      if (loadOptions.selectedRecords && loadOptions.selectedRecords.length) {
        selectedRecords = _(loadOptions.selectedRecords).pluck('Value');
      }

      //Записи которые были исключены
      if (loadOptions.notSelectedRecords && loadOptions.notSelectedRecords.length) {
        notSelectedRecords = _(loadOptions.notSelectedRecords).pluck('Value');
      }

      //если применили фильтр то придется сбросить кэш
      var isCurrentPeriodEnabled = Core.grid.reference.isCurrentPeriodEnabled();
      if (loadOptions.like !== me.lastLike || loadOptions.expression !== me.lastExpression || me.lastCurrentPeriodEnabled !== isCurrentPeriodEnabled) {
        me._cachedPages = {};
        me.lastLike = loadOptions.like;
        me.lastExpression = loadOptions.expression;
        me.lastCurrentPeriodEnabled = isCurrentPeriodEnabled;
      }

      //Если страница есть в кэше, то возьмем  из кэша
      if (me._cachedPages[loadOptions.page]) {
        var records = me._cachedPages[loadOptions.page];

        records = _(records).map(function (record) {
          if (!loadOptions.invertedMode) {
            record.isSelected = selectedRecords.indexOf(record.value) !== -1
          } else {
            record.isSelected = notSelectedRecords.indexOf(record.value) === -1
          }
          return record;
        });
        
        
        result.resolve(_(specialRecords.concat(records)).map(function (r) {
          r.id = ("" + r.value).makeSafeString(); return r
        }));
        return result.promise();
      }

      WA.SRV.call('/Reference.asmx/GetDistinctRequisiteValues', {
        ReferenceCode: me.settings.referenceName || WA.CR.getReferenceCode(),
        ReferenceView: me.settings.referenceView || WA.CR.getReferenceView(),
        RequisiteName: loadOptions.requisiteName,
        Filter: me.settings.filter,
        CustomFilter: loadOptions.like,
        SelectExpr: loadOptions.expression,
        Skip: loadOptions.skip,
        Take: loadOptions.take,
        QueryInstanceID: me.settings.queryInstanceID,
        QueryContext: me.settings.queryContext
      }).done(function (records) {
        records = _(records).map(function (item) {
          return {
            value: item.First,
            displayValue: $.trim(item.Second),
            type: '',
            isSelected: (!loadOptions.invertedMode) ? selectedRecords.indexOf(item.First) !== -1 : notSelectedRecords.indexOf(item.First) === -1
          }
        });

        me._cachedPages[loadOptions.page] = records;
        result.resolve(specialRecords.concat(records).map(function (r) {
          r.id = ("" + r.value).makeSafeString(); return r
        }));
      });

      return result.promise();
    }
  });

})(Core.grid);